export default "__VITE_PUBLIC_ASSET__0dde346f__"